import { removeCookie } from '@clearscore/helpers.cookies';

export default {
    /**
     * rxjs observer next handler to track segment events
     * @param {object} event object
     * @returns {void} dispatches event via segment
     */
    next: (event) => {
        const { analytics } = window;
        if (analytics) {
            switch (event.type) {
                case 'alias':
                    analytics.alias(event.props.uuid);
                    break;
                case 'identify':
                    analytics.identify(event.props.uuid, event.traits);
                    removeCookie('ajs_anonymous_id'); // remove segment cookie
                    break;
                case 'track':
                    analytics.track(event.name, event.props);
                    break;
                default:
                    break;
            }
        }
    },
};
